import Header from 'components/Header'
import { TTypeSignal } from 'interface'
import Signal from 'components/Signal'
import { useApplicationCtx } from 'context/application'

import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'
import { interWbNavigate } from '@interco/inter-webview-bridge'

import * as S from '../styles'

type TPropsErrorView = {
  headerTitle?: string
  icon?: TTypeSignal
  title?: string
  description?: string
  button?: {
    text?: string
    deeplink?: string
  }
  bottomSheetMode?: boolean
}

export const ErrorView = ({
  headerTitle,
  title,
  description,
  icon,
  button,
  bottomSheetMode,
}: TPropsErrorView) => {
  const { setShowBottomSheet } = useApplicationCtx()

  const redirect = () => {
    if (button?.deeplink === 'CLOSE') {
      setShowBottomSheet(false)
    } else if (button?.deeplink === 'BACK' || !button?.deeplink) {
      interWbNavigate.requestGoBack()
    } else if (button?.deeplink) {
      interWbNavigate.openDeepLink(button?.deeplink)
    }
  }

  return (
    <S.Wrapper>
      {!bottomSheetMode && <Header title={headerTitle || 'Check-in premiado'} />}
      <S.ErrorSection $bottomSheetMode={bottomSheetMode}>
        <Signal type={(icon as unknown as TTypeSignal) || 'alert'} />
        <Text variant="headline-h2" semiBold>
          {title || 'Houve um erro por aqui'}
        </Text>
        <Text variant="body-3">
          {description ||
            'No momento, não é possível acessar essa página. Você pode tentar novamente mais tarde.'}
        </Text>
        <S.FooterErrorSection>
          <Button fullWidth variant="primary" onClick={redirect}>
            {button?.text || 'Voltar'}
          </Button>
        </S.FooterErrorSection>
      </S.ErrorSection>
    </S.Wrapper>
  )
}

export default ErrorView
